import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
@Pipe({
  name: 'dateFormat',
})
export class dateFormat implements PipeTransform {

  transform(value: string) {
    // Number(value);
    var _value = new Date(value).getTime();

    var dif = Math.floor(((Date.now() - _value) / 1000) / 86400);

    if (dif < 30) {
      return convertToNiceDate(value);
    } else {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MMM-dd-yyyy');
      return value;
    }
  }
}

function convertToNiceDate(time: string) {
 var date = new Date(time),
    diff = (((new Date()).getTime() - date.getTime()) / 1000),
    daydiff = Math.floor(diff / 86400);

  if (isNaN(daydiff) || daydiff < 0 || daydiff >= 31)
    return '';

  //convert UTC to local
  var stillUtcStart = moment.utc(time).toDate();
  var localStart = moment(stillUtcStart).local();
  date = localStart.toDate();
  //end UTC

  return moment(date).format('LLLL');

  //var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  //daydiff == 0 && (
  //  diff < 60 && "Just now" ||
  //  diff < 120 && "1 minute ago" ||
  //  diff < 3600 && Math.floor(diff / 60) + " minutes ago" ||
  //  diff < 7200 && "1 hour ago" ||
  //  diff < 86400 && Math.floor(diff / 3600) + " hours ago") ||

  //  daydiff == 1 && "Yesterday at " + tConvert(date) ||

  //  daydiff < 8 && days[date.getDay()] + " at " + tConvert(date) ||
  //  //daydiff < 7 && daydiff + " days ago" ||
  //  daydiff < 31 && Math.ceil(daydiff / 7) + " week(s) ago";
}

function tConvert(time) {

  var hours = time.getHours();
  var minutes = time.getMinutes();

  // Check whether AM or PM
  var newformat = hours >= 12 ? 'PM' : 'AM';

  // Find current hour in AM-PM Format
  hours = hours % 12;

  // To display "0" as "12"
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;


  return (hours + ':' + minutes + ' ' + newformat);
}
